import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const newsApi = axios.create({ baseURL: BACKEND ? `${BACKEND}/api/news` : "" });

export const photoSrc = (url) => (url && BACKEND ? `${BACKEND}${url}` : "");

export const fmtPublished = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric", timeZone: "America/New_York" }) : "";

// Event times are entered and shown as Eastern wall-clock time ("2030-05-01T18:00").
const parseLocal = (s) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(s || "");
  return m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) : null;
};

export const fmtEvent = (event) => {
  const start = parseLocal(event?.start);
  if (!start) return "";
  const day = start.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" });
  const time = (d) => d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  const end = parseLocal(event?.end);
  if (!end) return `${day} · ${time(start)} ET`;
  const sameDay = end.toDateString() === start.toDateString();
  return sameDay
    ? `${day} · ${time(start)} – ${time(end)} ET`
    : `${day}, ${time(start)} – ${end.toLocaleDateString("en-US", { month: "long", day: "numeric" })}, ${time(end)} ET`;
};

export const eventShort = (event) => {
  const d = parseLocal(event?.start);
  return d ? { month: d.toLocaleDateString("en-US", { month: "short" }), day: d.getDate() } : null;
};
